export default __webpack_public_path__ + "assets/Beyond-Infinity.ttf.woff";